import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation blockUsername($blockeeId: String!) {
    blockUser(blockeeId: $blockeeId) {
      success
      message
    }
  }
`

export interface BlockUsernameInput {
  blockeeId: string
}

export interface BlockUsernameOutput {
  blockUser: {
    success: boolean
    message: string
  }
}

export const useBlockUsername = () => useMutation<BlockUsernameOutput, BlockUsernameInput>(mutation)
